import { render, staticRenderFns } from "./Ofertas.vue?vue&type=template&id=22f5c8c7&scoped=true"
import script from "./Ofertas.vue?vue&type=script&lang=js"
export * from "./Ofertas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f5c8c7",
  null
  
)

export default component.exports